import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../utils/withIntl";
import { Checkbox, Grid, IconButton, MenuItem, Select } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ColorPicker from "material-ui-color-picker";
import { red } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import { Close } from "@material-ui/icons";

function StylingV2(props) {
  const [styling, setStyling] = React.useState(
    typeof props.styling === "string" ? JSON.parse(props.styling) : props.styling
  );

  const updateStylingValue = (styling, keys, value) => {
    if (keys.length > 0) {
      let key = keys[0];
      if (!styling[key]) {
        styling[key] = {};
      }
      keys.splice(0, 1);
      if (keys.length > 0) {
        updateStylingValue(styling[key], keys, value);
      } else {
        styling[key] = value;
      }
    }
  };

  if (!styling) {
    return (
      <>
        <Button
          onClick={() => {
            setStyling({});
          }}
        >
          Add custom styling
        </Button>
      </>
    );
  }

  return (
    <>
      <Grid container>
        <Grid container item xs={12}>
          <Typography variant={"h6"}>Colors</Typography>
        </Grid>
        {props.disableZoom !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Disable zoom
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <Checkbox
                color={"primary"}
                checked={styling?.disable_zoom ?? false}
                onChange={(e) => {
                  let value = e.target.checked;
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["disable_zoom"], value);
                  setStyling(newStyling);
                }}
              />
            </Grid>
          </>
        )}
        {props.themeType !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Color Type
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <Select
                value={styling?.palette?.type ?? "null"}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "null") {
                    value = null;
                  }
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "type"], value);
                  setStyling(newStyling);
                }}
              >
                <MenuItem value={"null"}>User's preference</MenuItem>
                <MenuItem value={"light"}>Light Mode</MenuItem>
                <MenuItem value={"dark"}>Dark Mode</MenuItem>
              </Select>
            </Grid>
          </>
        )}
        {props.primaryColor !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Primary color
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div
                style={{
                  height: 10,
                  width: 10,
                  backgroundColor: styling?.palette?.primary?.main ?? props.primaryColorDefault ?? "#FF8C00",
                }}
              />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.primary?.main ?? props.primaryColorDefault ?? "#FF8C00"}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "primary", "main"], color);
                  setStyling(newStyling);
                }}
              />
            </Grid>
          </>
        )}
        {props.secondaryColor !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Secondary color
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div style={{ height: 10, width: 10, backgroundColor: styling?.palette?.secondary?.main ?? red[500] }} />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.secondary?.main ?? red[500]}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "secondary", "main"], color);
                  setStyling(newStyling);
                }}
              />
            </Grid>
          </>
        )}
        {props.warningColor !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Warning color
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div style={{ height: 10, width: 10, backgroundColor: styling?.palette?.warning?.main ?? "#ff9800" }} />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.warning?.main ?? "#ff9800"}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "warning", "main"], color);
                  setStyling(newStyling);
                }}
              />
            </Grid>
          </>
        )}
        {props.textPrimaryColor !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Text primary color
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div
                style={{
                  height: 10,
                  width: 10,
                  backgroundColor: styling?.palette?.text?.primary ?? props.textPrimaryColorDefault,
                }}
              />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.text?.primary ?? props.textPrimaryColorDefault ?? undefined}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "text", "primary"], color);
                  setStyling(newStyling);
                }}
              />
              {styling?.palette?.text?.primary && (
                <IconButton
                  size={"small"}
                  onClick={() => {
                    let newStyling = { ...styling };
                    updateStylingValue(newStyling, ["palette", "text", "primary"], null);
                    setStyling(newStyling);
                  }}
                >
                  <Close />
                </IconButton>
              )}
            </Grid>
          </>
        )}
        {props.textSecondaryColor !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Text secondary color
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div style={{ height: 10, width: 10, backgroundColor: styling?.palette?.text?.secondary }} />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.text?.secondary ?? undefined}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "text", "secondary"], color);
                  setStyling(newStyling);
                }}
              />
              {styling?.palette?.text?.secondary && (
                <IconButton
                  size={"small"}
                  onClick={() => {
                    let newStyling = { ...styling };
                    updateStylingValue(newStyling, ["palette", "text", "secondary"], null);
                    setStyling(newStyling);
                  }}
                >
                  <Close />
                </IconButton>
              )}
            </Grid>
          </>
        )}
        {props.textDisabledColor !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Text disabled color
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div style={{ height: 10, width: 10, backgroundColor: styling?.palette?.text?.disabled }} />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.text?.disabled ?? undefined}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "text", "disabled"], color);
                  setStyling(newStyling);
                }}
              />
              {styling?.palette?.text?.disabled && (
                <IconButton
                  size={"small"}
                  onClick={() => {
                    let newStyling = { ...styling };
                    updateStylingValue(newStyling, ["palette", "text", "disabled"], null);
                    setStyling(newStyling);
                  }}
                >
                  <Close />
                </IconButton>
              )}
            </Grid>
          </>
        )}
        {props.backgroundColor !== false && (
          <>
            {" "}
            <Grid container item xs={4} alignItems={"center"}>
              Background color
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div style={{ height: 10, width: 10, backgroundColor: styling?.palette?.background?.default }} />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.background?.default ?? undefined}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "background", "default"], color);
                  setStyling(newStyling);
                }}
              />
              {styling?.palette?.background?.default && (
                <IconButton
                  size={"small"}
                  onClick={() => {
                    let newStyling = { ...styling };
                    updateStylingValue(newStyling, ["palette", "background", "default"], null);
                    setStyling(newStyling);
                  }}
                >
                  <Close />
                </IconButton>
              )}
            </Grid>
          </>
        )}
        {props.backgroundColorPaper !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Background color paper
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div style={{ height: 10, width: 10, backgroundColor: styling?.palette?.background?.paper }} />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.background?.paper ?? undefined}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "background", "paper"], color);
                  setStyling(newStyling);
                }}
              />
              {styling?.palette?.background?.paper && (
                <IconButton
                  size={"small"}
                  onClick={() => {
                    let newStyling = { ...styling };
                    updateStylingValue(newStyling, ["palette", "background", "paper"], null);
                    setStyling(newStyling);
                  }}
                >
                  <Close />
                </IconButton>
              )}
            </Grid>
          </>
        )}
        {props.backgroundColorTertiary !== false && (
          <>
            <Grid container item xs={4} alignItems={"center"}>
              Background color tertiary
            </Grid>
            <Grid container item xs={8} alignItems={"center"}>
              <div style={{ height: 10, width: 10, backgroundColor: styling?.palette?.background?.tertiary }} />
              <ColorPicker
                name={"color"}
                value={styling?.palette?.background?.tertiary ?? undefined}
                onChange={(color) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["palette", "background", "tertiary"], color);
                  setStyling(newStyling);
                }}
              />
              {styling?.palette?.background?.tertiary && (
                <IconButton
                  size={"small"}
                  onClick={() => {
                    let newStyling = { ...styling };
                    updateStylingValue(newStyling, ["palette", "background", "tertiary"], null);
                    setStyling(newStyling);
                  }}
                >
                  <Close />
                </IconButton>
              )}
            </Grid>
          </>
        )}

        <Grid container item xs={12}>
          <Typography variant={"h6"}>Fonts</Typography>
        </Grid>
        {props.fontType !== false && (
          <>
            <Grid container item xs={4}>
              <Typography>Default Font family</Typography>
            </Grid>
            <Grid container item xs={8}>
              <Select
                value={styling?.typography?.fontFamily ?? props.fontTypeDefault ?? "Poppins"}
                onChange={(e) => {
                  let newStyling = { ...styling };
                  updateStylingValue(newStyling, ["typography", "fontFamily"], e.target.value);
                  setStyling(newStyling);
                }}
              >
                <MenuItem value={"Poppins"}>Poppins</MenuItem>
                <MenuItem value={"Vapiano"}>Vapiano</MenuItem>
                <MenuItem value={"VapianoBold"}>VapianoBold</MenuItem>
                <MenuItem value={"VapianoLight"}>VapianoLight</MenuItem>
                <MenuItem value={"VapianoRegular"}>VapianoRegular</MenuItem>
                <MenuItem value={"VapianoSemiBold"}>VapianoSemiBold</MenuItem>
              </Select>
            </Grid>
          </>
        )}
      </Grid>
      <Button
        onClick={() => {
          if (styling?.palette?.text && Object.keys(styling?.palette?.text).length === 0) {
            styling.palette.text = null;
          }
          if (styling?.palette?.background && Object.keys(styling?.palette?.background).length === 0) {
            styling.palette.background = null;
          }

          if (styling?.palette && Object.keys(styling?.palette).length === 0) {
            styling.palette = null;
          }
          if (styling?.typography && Object.keys(styling?.typography).length === 0) {
            styling.typography = null;
          }

          props.onSave(styling);
        }}
        variant={"contained"}
        color={"primary"}
      >
        SAVE
      </Button>
      <Button
        onClick={() => {
          let newStyling = { ...styling };
          if (!props.main) {
            newStyling = null;
          } else {
            newStyling.palette = null;
            newStyling.typography = null;
          }
          setStyling(newStyling);
          props.onSave(newStyling);
        }}
        variant={"contained"}
        color={"primary"}
      >
        Remove custom styling
      </Button>
    </>
  );
}

StylingV2.defaultProps = {
  disableZoom: false,
};

StylingV2.propTypes = {
  themeType: PropTypes.bool,
  primaryColor: PropTypes.bool,
  primaryColorDefault: PropTypes.string,
  secondaryColor: PropTypes.bool,
  warningColor: PropTypes.bool,
  textPrimaryColor: PropTypes.bool,
  textPrimaryColorDefault: PropTypes.string,
  textSecondaryColor: PropTypes.bool,
  textDisabledColor: PropTypes.bool,
  backgroundColor: PropTypes.bool,
  backgroundColorPaper: PropTypes.bool,
  backgroundColorTertiary: PropTypes.bool,
  fontType: PropTypes.bool,
  fontTypeDefault: PropTypes.string,
  disableZoom: PropTypes.bool,
};

export default withIntl(StylingV2);
